
import memoizeOne from 'memoize-one';

export default memoizeOne(function (displaced) {
  return displaced.reduce(function (map, displacement) {
    map[displacement.draggableId] = displacement;
    return map;
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/esm/state/get-displacement-map.js
// module id = 641
// module chunks = 0